import { Amplify, Auth } from 'aws-amplify'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { CognitoUserPool } from 'amazon-cognito-identity-js'
export const userPoolId = process.env.NEXT_PUBLIC_USER_POOL_ID as string
export const clientId = process.env.NEXT_PUBLIC_CLIENT_ID as string
export const cognitoDomain = process.env.NEXT_PUBLIC_COGNITO_DOMAIN as string
export const linkedInProviderName =
  (process.env.NEXT_PUBLIC_COGNITO_LINKEDIN_PROVIDER_NAME as string) ??
  'LinkedIn'
export const cognitoRegion =
  (process.env.NEXT_PUBLIC_AWS_REGION as string) ?? userPoolId?.split('_')[0]

const getBrowserOrigin = () => {
  if (typeof window === 'undefined') return ''
  return window.location.origin
}

const getRedirectSignIn = () =>
  (process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_IN as string) ??
  `${getBrowserOrigin()}/oauth/callback`

const getRedirectSignOut = () =>
  (process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_OUT as string) ??
  `${getBrowserOrigin()}/login`

let configured = false

const clearLegacyCognitoCookies = () => {
  if (typeof document === 'undefined') return

  const domain = process.env.NEXT_PUBLIC_DOMAIN
  const parentDomain = domain?.split('.').slice(-2).join('.')
  for (const cookie of document.cookie.split(';')) {
    const name = cookie.trim().split('=')[0]
    if (!name.startsWith('CognitoIdentityServiceProvider.')) continue

    for (const scope of [undefined, domain, parentDomain]) {
      document.cookie = `${name}=; Max-Age=0; Path=/${scope ? `; Domain=${scope}` : ''}`
    }
  }
}

export const userPool = new CognitoUserPool({
  UserPoolId: userPoolId,
  ClientId: clientId,
})

export const configureCognito = () => {
  if (configured || !userPoolId || !clientId) return

  clearLegacyCognitoCookies()
  Amplify.configure({
    Auth: {
      region: cognitoRegion,
      userPoolId,
      userPoolWebClientId: clientId,
      oauth: cognitoDomain
        ? {
            domain: cognitoDomain,
            scope: [
              'openid',
              'email',
              'profile',
              'aws.cognito.signin.user.admin',
            ],
            redirectSignIn: getRedirectSignIn(),
            redirectSignOut: getRedirectSignOut(),
            responseType: 'code',
          }
        : undefined,
    },
  })

  configured = true
}

export const signInWithGoogle = async () => {
  configureCognito()

  if (!cognitoDomain) {
    throw new Error('NEXT_PUBLIC_COGNITO_DOMAIN is required for Google SSO')
  }

  await Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
  })
}

export const signInWithLinkedIn = async () => {
  configureCognito()

  if (!cognitoDomain) {
    throw new Error('NEXT_PUBLIC_COGNITO_DOMAIN is required for LinkedIn SSO')
  }

  await Auth.federatedSignIn({
    customProvider: linkedInProviderName,
  })
}

export const getHostedAuthenticatedUser = async () => {
  configureCognito()
  return Auth.currentAuthenticatedUser()
}

export const signOutOfCognito = async () => {
  configureCognito()
  await Auth.signOut()
}
